export default __webpack_public_path__ + "static/media/Anexo-gray.c8480b9a.svg";